<script>
export default {
  methods: {
    removeDuplicates(array) {
      return array.reduce((accumulator, current) => {
        const duplicate = accumulator.find(item => item.text === current.text)
        if (!duplicate) {
          return accumulator.concat([current])
        } else {
          return accumulator
        }
      }, [])
    },
  },
}
</script>
